import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@mbs-reseller/app/app.component';
import { appConfig } from '@mbs-reseller/app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
